"use strict";
module.exports = function (app) {
    // a directive to auto-increase the bidding price
    app.directive('increaseBidInput', ['$compile', 'BiddingRateIncreaseFactory', function ($compile, BiddingRateIncreaseFactory) {
        return {
            restrict: 'E',
            scope: false,
            controller:['$scope' ,function ($scope, element, attrs){
                //automatical increase the price
                $scope.bid.increasedDealPrice = BiddingRateIncreaseFactory.autoIncreaseBidFn($scope.bid.price);

            }],
            template: "<div class='price-input-wrapper'>" +
                      "<input type='number' ng-model='bid.increasedDealPrice' class='deal-price'>" +
                      "<div>&euro;</div>" +
                      "</div>"
        };
    }]);

};



/*****************
 ** WEBPACK FOOTER
 ** ./bidding_product/js/directive/increase_bid_input.directive.js
 ** module id = 55
 ** module chunks = 0
 **/